import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { ProprietariosCadastroDto } from '@usucampeao/lib-reurb-simplificado';
@Component({
  selector: 'usucampeao-modal-comprovante-renda',
  templateUrl: './modal-comprovante-renda.component.html',
  styleUrls: ['./modal-comprovante-renda.component.scss']
})
export class ModalComprovanteRendaComponent {
  @Input() set htmlComprovanteRenda(htmlContent: string) {
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }

  public htmlContent: SafeHtml;

  public proprietario!: ProprietariosCadastroDto;
  public conjuge!: ProprietariosCadastroDto;

  constructor(
    private readonly sanitizer: DomSanitizer,
    private modalCtrl: ModalController,
  ) { }

  public imprimir() {
    const container = document.getElementById('print-container');
    if (container) {
      // Pega o HTML já sanitizado e renderizado pelo Angular
      const htmlToPrint = container.innerHTML;
      const printWindow = window.open('', '_blank');

      if (printWindow) {
        // Escreve o HTML que veio do endpoint na nova janela
        printWindow.document.write(htmlToPrint);
        printWindow.document.close();

        // Dispara a impressão
        printWindow.print();

        // Fecha a janela após a impressão ser acionada (opcional)
        // printWindow.close();
      }
    }
  }

  public dismiss(): void {
    this.modalCtrl.dismiss();
  }
}
